/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Household_NameInputs */

const en_setup_household_name = /** @type {(inputs: Setup_Household_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Household name`)
};

const de_setup_household_name = /** @type {(inputs: Setup_Household_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Haushalts`)
};

/**
* | output |
* | --- |
* | "Household name" |
*
* @param {Setup_Household_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const setup_household_name = /** @type {((inputs?: Setup_Household_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Household_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_setup_household_name(inputs)
	return en_setup_household_name(inputs)
});